import { render, staticRenderFns } from "./tooltip-primary.vue?vue&type=template&id=7987dfbc&scoped=true&"
import script from "./tooltip-primary.vue?vue&type=script&lang=js&"
export * from "./tooltip-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7987dfbc",
  null
  
)

export default component.exports